import React from 'react';
import { APP_TERMS } from '../../../app-terms';
import { Col, Form, Row, Upload } from 'antd';
import PropTypes from 'prop-types';
import apiService from '../../../axios/apiService';
import { CASE_FORM_TYPES, UPLOAD_STATUS } from '../../../appContants';

const UploadListItem = ({ originNode }) => {
  return <div style={{ cursor: 'pointer' }}>{originNode}</div>;
};
UploadListItem.propTypes = {
  originNode: PropTypes.any,
  file: PropTypes.any,
};
const UploadFiles = ({ form, defaultFileList, onUploadingChange }) => {

  const handleUpload = async ({ file, onSuccess, onProgress }) => {
    try {
      let uploadComplete = false;
      const safeOnProgress = (event) => {
        if (!uploadComplete) onProgress(event);
      };
      // Fetch the presigned URL from the server
      const signedUrl = await apiService.getPresignedUrl({
        fileName: file?.name,
        fileSize: file?.size,
        fileContentType: file?.type || 'application/dicom', // By default save as DICOM
      });
      if (signedUrl) {
        // Upload file using the signed URL
        const formData = new FormData();
        const fields = signedUrl?.preSigned?.fields;
        for (const key in fields) {
          if (fields.hasOwnProperty.call(fields, key)) {
            const value = fields[key];
            formData.append(key, value);
          }
        }
        formData.append('file', file);
        await apiService.uploadWithPresignedUrl(
          signedUrl?.preSigned?.url,
          formData,
          safeOnProgress
        );
        uploadComplete = true;
        onSuccess({
          result: UPLOAD_STATUS.success,
          file: { ...file, uid: signedUrl?.objectKey },
        });
      }
    } catch (error) {
      console.log('error on upload ', error);
      onSuccess({
        result: UPLOAD_STATUS.failure,
        file: { ...file },
      });
    }
  };
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  return (
    <>
      <Form
        name={CASE_FORM_TYPES.uploadFiles}
        form={form}
        layout="vertical"
        autoComplete="off"
      >
        <Row gutter={16} className="mt-3">
          <Col>
            <h4>{`${APP_TERMS.generic_admin} ${APP_TERMS.generic_report}`}</h4>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="files"
              valuePropName="fileList"
              getValueFromEvent={normFile}
              required
              rules={[
                // {
                //   message: APP_TERMS.file_upload_invalid_validation,
                //   validator: (_, value) => {
                //     return value?.length
                //       ? Promise.resolve()
                //       : Promise.reject(
                //           new Error(APP_TERMS.file_upload_invalid_validation)
                //         );
                //   },
                // },
                {
                  message: APP_TERMS.file_upload_to_server_failed,
                  validator: (_, value) => {
                    const hasFaultyUpload =
                      value.findIndex(
                        (v) => v?.response?.result === UPLOAD_STATUS.failure
                      ) > -1;
                    return hasFaultyUpload
                      ? Promise.reject(APP_TERMS.file_upload_to_server_failed)
                      : Promise.resolve();
                  },
                },
              ]}
            >
              <Upload.Dragger
                name="files"
                accept='.pdf'
                defaultFileList={defaultFileList}
                customRequest={handleUpload}
                onChange={(info) => {
                  const list = info.fileList ?? [];
                  form?.setFieldValue('files', list);
                  onUploadingChange?.(list.some((f) => f?.status === 'uploading'));
                }}
                itemRender={(originNode, file) => (
                  <UploadListItem originNode={originNode} file={file} />
                )}
              >
                <p className="ant-upload-drag-icon px-3 pt-3">
                  <i className="fa fa-3x fa-arrow-up-from-bracket"></i>
                </p>
                <p className="ant-upload-text px-3">
                  Click or drag file to this area to upload
                </p>
                <p className="ant-upload-hint px-3 pb-3">
                  Support for a single or bulk upload.
                </p>
              </Upload.Dragger>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};

UploadFiles.propTypes = {
  form: PropTypes.any,
  defaultFileList: PropTypes.array,
  onUploadingChange: PropTypes.func,
};

export default UploadFiles;
